import * as React from 'react';
import en from './locales/KebabActionCell.en.json';
import normalizeLocaleData from '../../utils/i18n/normalizeLocaleData';
import noop from '../../utils/noop';
import AdditionalIntl from '../../I18n/AdditionalIntl/AdditionalIntl';
import ButtonLabel from '../../Buttons/ButtonLabel/ButtonLabel';
import CircleButton from '../../Buttons/CircleButton/CircleButton';
import I18n, { isI18nObject, isI18nString } from '../../I18n/I18n/I18n';
import Icon from '../../Icons/Icon/Icon';
import IconButton from '../../Buttons/IconButton/IconButton';
import Menu from '../../Menu/Menu';
import MenuItem from '../../Menu/MenuItem';
import Spinner from '../../Spinner/Spinner';
import ThemeContext from '../../ThemeContext';
import Tooltip from '../../Tips/Tooltip/Tooltip';
import { ReactComponent as Locked } from '../../../icons/Locked/Locked.svg';
import './KebabActionCell.css';
var messages = normalizeLocaleData(en, '@dm/components.kebab-action-cell');
var DEFAULT_ACTIONS = [];
function getTooltip(original) {
  var tooltip = original.lockedTooltip;
  if (isI18nObject(tooltip)) {
    return tooltip;
  } else if (isI18nString(tooltip)) {
    return {
      id: tooltip
    };
  } else {
    return {
      id: '@dm/components.kebab-action-cell.locked'
    };
  }
}
export default function KebabActionCell(_ref) {
  var original = _ref.original,
    row = _ref.row,
    _ref$tooltipLabel = _ref.tooltipLabel,
    tooltipLabel = _ref$tooltipLabel === void 0 ? '@dm/components.kebab-action-cell.menu' : _ref$tooltipLabel;
  var loading = original.actionsLoading || row.actionsLoading || false;
  var locked = original.locked || row.locked || false;
  var lockedTooltip = getTooltip(original);
  var actions = row.actions || DEFAULT_ACTIONS;
  var icon = original.icon || row.icon || null;
  return actions.length > 0 ? /*#__PURE__*/React.createElement(Menu, {
    orientation: "right",
    button: function button(_ref2) {
      var buttonProps = _ref2.buttonProps,
        expanded = _ref2.expanded,
        setRef = _ref2.setRef;
      return /*#__PURE__*/React.createElement(AdditionalIntl, {
        namespace: "@dm/components.kebab-action-cell",
        messages: messages
      }, /*#__PURE__*/React.createElement("div", {
        className: "_dm-actions-cell__wrapper"
      }, loading && /*#__PURE__*/React.createElement("span", {
        className: "_dm-actions-cell__spinner"
      }, /*#__PURE__*/React.createElement(Spinner, null)), locked && /*#__PURE__*/React.createElement(Tooltip, {
        i18n: lockedTooltip
      }, function (_ref3) {
        var ref = _ref3.ref,
          labelledby = _ref3.labelledby,
          events = _ref3.events;
        return /*#__PURE__*/React.createElement(ThemeContext.Provider, {
          value: 'dm'
        }, /*#__PURE__*/React.createElement(IconButton, Object.assign({
          ref: ref,
          "aria-labelledby": labelledby,
          onClick: noop,
          className: "_dm-actions-cell__locked"
        }, events), /*#__PURE__*/React.createElement(ButtonLabel, {
          i18n: lockedTooltip,
          hideLabel: true,
          className: "_dm-actions-cell__locked-label"
        }), /*#__PURE__*/React.createElement(Icon, {
          width: 13,
          height: 13
        }, /*#__PURE__*/React.createElement(Locked, {
          width: 13,
          height: 13
        }))));
      }), icon, /*#__PURE__*/React.createElement(Tooltip, {
        i18nKey: tooltipLabel,
        neverShow: expanded
      }, function (_ref4) {
        var ref = _ref4.ref,
          labelledby = _ref4.labelledby,
          events = _ref4.events;
        return /*#__PURE__*/React.createElement(CircleButton, Object.assign({}, buttonProps, {
          ref: setRef(ref),
          "aria-labelledby": labelledby
        }, events), /*#__PURE__*/React.createElement("span", {
          className: "mdi mdi-dots-vertical"
        }));
      })));
    }
  }, actions.map(function (_ref5, idx) {
    var display = _ref5.display,
      displayComponent = _ref5.displayComponent,
      callback = _ref5.callback,
      className = _ref5.className,
      disabled = _ref5.disabled;
    var onClick = function onClick(e) {
      callback && callback(e, original);
    };
    return /*#__PURE__*/React.createElement(MenuItem, {
      key: "menu-item-".concat(idx),
      disabled: disabled || loading,
      onClick: onClick,
      className: className
    }, !!displayComponent ? displayComponent : /*#__PURE__*/React.createElement(I18n, {
      i18n: display
    }));
  })) : null;
}